import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Alert, Col, List, Row, Spin } from "antd";
import { fetchCounsilors, fetchPrevCounsilor } from "api/counsilors";
import ChangeCounsilor from "components/Modal/ChangeCounsilor";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AvatarComp from "themes/elements/Avatar";
import ButtonComp from "themes/elements/Button";
import { isPermit } from "utils/permissionCheck";
import Initiatives from "./Initiatives";
import ProfileCard from "./ProfileCard";
import "./accordian.scss";

function RightSection() {
  const [open, setOpen] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [selectLoading, setSelectLoading] = useState(false);

  const [counsilorData, setCounsilorData] = useState([]);

  const [isVisible, setIsVisible] = useState(false);
  const [fetchedCouncillors, setFetchedCouncillors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { selectedUser } = useSelector((state) => state.wards);

  // Function to fetch previous councillors
  const getCouncillors = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetchPrevCounsilor({
        page: 1,
        perPage: 100,
        wardCode: selectedUser?.ward,
      });
      setFetchedCouncillors(response.councilors || []); // Assuming the response is an object with data
    } catch (err) {
      setError("Failed to load councillors");
    } finally {
      setLoading(false);
    }
  };

  // Call getCouncillors when the component mounts
  useEffect(() => {
    getCouncillors();
  }, []);

  useEffect(() => {
    fetchCouncillors(); // Call the fetch function on initial render
  }, [searchInput]); // Empty dependency array means this effect will only run once after the initial render

  const fetchCouncillors = async () => {
    try {
      setSelectLoading(true); // Start spinner
      const params = {
        page: 1,
        perPage: 100,
        status: 1,
        ...(searchInput ? { councilorName: searchInput } : { limit: 100 }),
      };

      const response = await fetchCounsilors(params);

      if (response?.councilors) {
        const formattedCouncillors = response.councilors.map((councilor) => ({
          key: councilor.councilor_id,
          label: `${councilor.first_name} ${councilor.last_name}`,
          ...councilor,
        }));

        setCounsilorData(formattedCouncillors);
      }
    } catch (error) {
    } finally {
      setSelectLoading(false); // Stop spinner
    }
  };

  // Toggle visibility of the councillors list
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className="flex flex-column gap-6 w-full">
      {/* Profile Card */}
      {selectedUser.councillor ? (
        <ProfileCard setOpen={setOpen} open={setOpen} />
      ) : (
        <div className="flex justify-center">
          {isPermit(5, "edit") && (
            <ButtonComp prefix onClick={() => setOpen(true)}>
              Add councillor
            </ButtonComp>
          )}
        </div>
      )}

      <div>
        <div className="toggle gap-2 flex" onClick={toggleVisibility}>
          <p className="previous_councillors">
            {isVisible
              ? "Hide all previous councillors"
              : "Show all previous councillors"}
          </p>
          <span className="icon">
            {isVisible ? <UpOutlined /> : <DownOutlined />}
          </span>
        </div>

        {isVisible && (
          <div style={{ marginTop: 20, maxHeight: 400, overflowY: "auto" }}>
            {/* Loading State */}
            {loading && <Spin size="large" />}

            {/* Error State */}
            {error && <Alert message={error} type="error" />}

            {/* Render councillors list */}
            {!loading && !error && (
              <List
                itemLayout="horizontal"
                dataSource={fetchedCouncillors}
                renderItem={(item) => (
                  <List.Item>
                    <Row style={{ width: "100%" }}>
                      <span className="mr-15">
                        {item?.councilor_image ? (
                          <AvatarComp
                            size={62}
                            shape="square"
                            src={item?.councilor_image}
                            blue
                          />
                        ) : (
                          <AvatarComp size={62} shape="square">
                            {item.first_name.replace(" ", "")[0]}
                          </AvatarComp>
                        )}
                      </span>
                      <Col span={16}>
                        <div className="flex flex-column">
                          <h4>{item.first_name + " " + item.last_name}</h4>
                          <div className="flex gap-2">
                            <div className="value-container">
                              <p className="sub">Phone Number </p>
                              <p className="value">{item.phone_number}</p>
                            </div>
                            <div>
                              <p className="sub">Tenure </p>
                              <p className="value">{item.term}</p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </List.Item>
                )}
              />
            )}
          </div>
        )}
      </div>
      <ChangeCounsilor
        open={open}
        setOpen={setOpen}
        counsilors={counsilorData}
        seletedItem={selectedUser}
        setSearchInput={setSearchInput}
        selectLoading={selectLoading}
      />

      {/* Initiatives */}
      <Initiatives />
    </div>
  );
}

export default RightSection;
